import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: ["status-rectangle", _ctx.statusClass]
  }, [
    _createVNode("span", null, _toDisplayString(_ctx.getStatusString), 1)
  ], 2))
}